import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "gee_token";

const client = axios.create({ baseURL: `${BACKEND_URL}/api` });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname.startsWith("/admin") && window.location.pathname !== "/admin") {
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = "/admin";
    }
    return Promise.reject(err);
  }
);

export const auth = {
  async login(email, password) {
    const { data } = await client.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    return data;
  },
  logout() {
    localStorage.removeItem(TOKEN_KEY);
  },
  isAuthed() {
    return !!localStorage.getItem(TOKEN_KEY);
  },
};

export const postsApi = {
  list: (params = {}) => client.get("/posts", { params }).then((r) => r.data),
  get: (slug) => client.get(`/posts/${slug}`).then((r) => r.data),
  adminList: () => client.get("/admin/posts").then((r) => r.data),
  create: (payload) => client.post("/posts", payload).then((r) => r.data),
  update: (id, payload) => client.put(`/posts/${id}`, payload).then((r) => r.data),
  remove: (id) => client.delete(`/posts/${id}`).then((r) => r.data),
};

export const categoriesApi = {
  list: () => client.get("/categories").then((r) => r.data),
  create: (name) => client.post("/categories", { name }).then((r) => r.data),
  remove: (id) => client.delete(`/categories/${id}`).then((r) => r.data),
};

export const newsletterApi = {
  subscribe: (name, email, turnstileToken = "") =>
    client.post("/newsletter/subscribe", { name, email, turnstile_token: turnstileToken }).then((r) => r.data),
  subscribers: () => client.get("/newsletter/subscribers").then((r) => r.data),
  remove: (email) => client.delete(`/newsletter/subscribers/${encodeURIComponent(email)}`).then((r) => r.data),
  send: (payload) => client.post("/newsletter/send", payload).then((r) => r.data),
  sendPost: (postId, test = false) =>
    client.post(`/newsletter/send-post/${postId}?test=${test ? "true" : "false"}`).then((r) => r.data),
};

export const videosApi = {
  list: () => client.get("/videos").then((r) => r.data),
  create: (payload) => client.post("/videos", payload).then((r) => r.data),
  update: (id, payload) => client.put(`/videos/${id}`, payload).then((r) => r.data),
  remove: (id) => client.delete(`/videos/${id}`).then((r) => r.data),
};

export const contactApi = {
  submit: (payload) => client.post("/contact", payload).then((r) => r.data),
  list: () => client.get("/contact").then((r) => r.data),
  remove: (id) => client.delete(`/contact/${id}`).then((r) => r.data),
};

// Extract a YouTube video id from common URL formats
export const getYouTubeId = (url = "") => {
  const m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
  return m ? m[1] : null;
};

export const uploadApi = {
  async uploadImage(file, onProgress) {
    const fd = new FormData();
    fd.append("file", file);
    const { data } = await client.post("/upload", fd, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
      },
    });
    return { ...data, absoluteUrl: `${BACKEND_URL}${data.url}` };
  },
};
